import { render, staticRenderFns } from "./mobileLayout.vue?vue&type=template&id=67070a68&scoped=true&"
import script from "./mobileLayout.vue?vue&type=script&lang=js&"
export * from "./mobileLayout.vue?vue&type=script&lang=js&"
import style0 from "./mobileLayout.vue?vue&type=style&index=0&id=67070a68&lang=scss&scoped=true&"
import style1 from "./mobileLayout.vue?vue&type=style&index=1&id=67070a68&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67070a68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67070a68')) {
      api.createRecord('67070a68', component.options)
    } else {
      api.reload('67070a68', component.options)
    }
    module.hot.accept("./mobileLayout.vue?vue&type=template&id=67070a68&scoped=true&", function () {
      api.rerender('67070a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/mobileLayout.vue"
export default component.exports